import z from "zod";

const openaiErrorTypeValues = ["API_REQUEST_FAILED", "STRUCTURED_OUTPUT_SCHEMA_INVALID"] as const;

const openaiErrorTypeSchema = z.enum(openaiErrorTypeValues);
const OpenaiErrorType = openaiErrorTypeSchema.enum;
type OpenaiErrorType = z.infer<typeof openaiErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type OpenaiErrors =
  | {
      errorType: typeof OpenaiErrorType.API_REQUEST_FAILED;
      data: {
        model?: string;
        requestType?: string;
      };
    }
  | {
      errorType: typeof OpenaiErrorType.STRUCTURED_OUTPUT_SCHEMA_INVALID;
      data: {
        model?: string;
        requestType?: string;
      };
    };

export const openaiErrorDetails: Record<OpenaiErrorType, ErrorDetails> = {
  [OpenaiErrorType.API_REQUEST_FAILED]: {
    sentryDescription: "OpenAI API request failed",
  },
  [OpenaiErrorType.STRUCTURED_OUTPUT_SCHEMA_INVALID]: {
    sentryDescription: "OpenAI structured output failed schema validation",
  },
};
